import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { Typography } from '@material-ui/core'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch'
import { useClickMenuItem } from 'components/Workspace2EditorActionBar/hooks/useClickMenuItem'
import { useShallowEditorActionBar } from 'components/Workspace2EditorActionBar/store/EditorActionBarStore'
import {
    VisibilitySettingsActionType,
    VisibilitySettingsStates,
} from 'components/WorkspaceEditor/types/editorActionBar.type'

import React, { memo } from 'react'
const SELECTED_COLOR = '#1899D4'
const UNSELECTED_COLOR = '#d3d3d3'
const UNSELECTED_BORDER = '1px solid #bdbdbd'
interface VisibilitySettingsMenuItemProps {
    classes: ClassNameMap<string>
    actionLabel: VisibilitySettingsActionType
    selectedKey: keyof VisibilitySettingsStates
}

export const VisibilitySettingsMenuItem = memo<VisibilitySettingsMenuItemProps>(
    ({ classes, actionLabel, selectedKey }) => {
        const { onClickMenuItem } = useClickMenuItem()
        const { visibilitySettingValues } = useShallowEditorActionBar(
            (state) => ({
                visibilitySettingValues: state.visibilitySettingValues,
            })
        )
        const isSelected = visibilitySettingValues[selectedKey]
        return (
            <GridContainer
                data-testid={`visibilitySettingsMenu-${selectedKey}`}
                className={classes.menuItemContainer}
            >
                <ToggleSwitch
                    onChange={(e) =>
                        onClickMenuItem(selectedKey, e.target.checked)
                    }
                    size="small"
                    checked={isSelected}
                    aria-label={`${actionLabel} toggle`}
                    sliderTrackColor={
                        isSelected ? SELECTED_COLOR : UNSELECTED_COLOR
                    }
                    sliderThumbBorder={
                        isSelected
                            ? `1px solid ${SELECTED_COLOR}`
                            : UNSELECTED_BORDER
                    }
                />
                <Typography className={classes.menuItemLabel}>
                    {actionLabel}
                </Typography>
            </GridContainer>
        )
    }
)
